import { Grid } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { deleteMyList, setDialog } from "../../CorpUser.Slice";

const DeleteDialog = () => {
  const translate = useTranslate();
  const { isOpen, data, listType } = useAppSelector((state) => state.CorpDashboard.dialogs.deleteList);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setDialog({ dialogName: "deleteList", isOpen: false, data: {} }));
  };

  const handleDelete = async () => {
    dispatch(deleteMyList(data));
  };

  return (
    <DialogFormation
      openDialog={isOpen}
      handleClose={handleClose}
      title={
        listType === "dynamic"
          ? translate("list.delete.dynamic.filter.dailog.title")
          : translate("list.delete.static.filter.dailog.title")
      }
      actionConfig={
        <div className="modal-config-wrapper">
          <Button label="Cancel" variant="secondary" onClick={handleClose} />
          <Button variant="alert" label="Delete" onClick={handleDelete} />
        </div>
      }
    >
      <Grid container px={"16px"}>
        <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
          {listType === "dynamic"
            ? translate("list.delete.dynamic.filter.dailog.description")
            : translate("list.delete.static.filter.dailog.description")}
          <br /> {translate("list.delete.common.filter.dailog.description.secondary")}
        </Typography>
      </Grid>
    </DialogFormation>
  );
};

export default DeleteDialog;
